var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 250,
    height: 19.725,
    viewBox: "0 0 250 19.725",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1{fill:#2ac19f}\r\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(-90.2 -87.2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x31_",
    transform: "translate(90.2 87.2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    d: "M106.538 97.035H95.7V90.2h-5.5v18.493h5.5v-7.1h10.837v7.1h5.521V90.2h-5.521z",
    transform: "translate(-90.2 -89.584)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    d: "M226.528 87.2c-3.612 0-6.65.883-8.744 2.566a9.725 9.725 0 0 0 0 14.573 13.854 13.854 0 0 0 8.744 2.586c7.43 0 12.048-3.777 12.048-9.852 0-6.096-4.618-9.873-12.048-9.873zm0 15.209c-4.044 0-6.445-1.991-6.445-5.337s2.4-5.337 6.445-5.337 6.445 1.991 6.445 5.337c0 3.328-2.422 5.337-6.445 5.337z",
    transform: "translate(-188.987 -87.2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    d: "M355.1 90.2h-5.5v18.493h17.857v-4.454H355.1z",
    transform: "translate(-296.357 -89.584)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    d: "M465.128 87.2c-3.612 0-6.65.883-8.744 2.566a9.726 9.726 0 0 0 0 14.573 13.854 13.854 0 0 0 8.744 2.586c7.43 0 12.048-3.777 12.048-9.852.024-6.096-4.597-9.873-12.048-9.873zm0 15.209c-4.044 0-6.445-1.991-6.445-5.337s2.4-5.337 6.445-5.337 6.445 1.991 6.445 5.337c0 3.328-2.402 5.337-6.445 5.337z",
    transform: "translate(-378.613 -87.2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    d: "M587 94.633h7.574v14.06h5.526v-14.06h7.615V90.2H587z",
    transform: "translate(-485.029 -89.584)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    d: "M735.667 96.542c0-3.92-3.223-6.342-8.415-6.342H714.3v18.514h5.48v-5.788h5.275l4.844 5.788h6.424l-5.439-6.281c3.079-.944 4.783-3.033 4.783-5.891zm-8.826 2.319h-7.1v-4.453h7.1c2.2 0 3.222.7 3.222 2.217s-1.026 2.237-3.222 2.237z",
    transform: "translate(-586.201 -89.584)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    d: "m847.965 90.2-9.565 18.514h5.788l1.724-3.51h9.955l1.724 3.51h5.87L853.917 90.2zm-.123 11.022L850.9 95l3.038 6.219z",
    transform: "translate(-684.829 -89.584)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    d: "M979.2 90.2v18.493h5.5V90.2z",
    transform: "translate(-796.729 -89.584)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    d: "M1015.257 90.2 1006 99.436l9.257 9.257h6.958l-9.257-9.257 9.257-9.236z",
    transform: "translate(-818.028 -89.584)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    className: "cls-1",
    d: "m1109.85 99.436 3.9-3.879-5.378-5.357h-7.615l-9.257 9.236 9.257 9.257h7.779l-9.257-9.257 5.3-5.275z",
    transform: "translate(-885.979 -89.584)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    className: "cls-1",
    d: "M1212.872 90.2h-7.779l9.257 9.236-5.275 5.3-5.3-5.3-3.879 3.9 5.357 5.357h7.615l9.257-9.257z",
    transform: "translate(-972.129 -89.584)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e34a51ce0877948deab7178981e01791.svg";
export { ForwardRef as ReactComponent };